import { useEffect, useState } from 'react';

import {
  AuthentificationState,
  AuthentificationStatus,
  useAmplifyServiceContext,
  useRouteInfo,
  useRouteNavigation,
} from '@scorenco/core';

import { LoadingScreen } from '../../components/LoadingScreen';

import AuthentificationBecomeFan from './AuthentificationBecomeFan/AuthentificationBecomeFan.desktop';
import AuthentificationConfirmForgotPassword from './AuthentificationConfirmForgotPassword/AuthentificationConfirmForgotPassword.desktop';
import AuthentificationConfirmSignUp from './AuthentificationConfirmSignUp/AuthentificationConfirmSignUp.desktop';
import AuthentificationForgotPassword from './AuthentificationForgotPassword/AuthentificationForgotPassword.desktop';
import AuthentificationSelectClub from './AuthentificationSelectClub/AuthentificationSelectClub.desktop';
import AuthentificationSelectSport from './AuthentificationSelectSport/AuthentificationSelectSport.desktop';
import AuthentificationSelectTeam from './AuthentificationSelectTeam/AuthentificationSelectTeam.desktop';
import AuthentificationSignedOut from './AuthentificationSignedOut/AuthentificationSignedOut.desktop';
import AuthentificationSignIn from './AuthentificationSignIn/AuthentificationSignIn.desktop';
import AuthentificationSignUp from './AuthentificationSignUp/AuthentificationSignUp.desktop';
import { AuthentificationLayout } from './components/AuthentificationLayout.desktop';

const Authentification = () => {
  const { authState, status, changeState } = useAmplifyServiceContext();
  const routeNavigation = useRouteNavigation();
  const routeInfo = useRouteInfo();
  const authStateParam = routeInfo.query
    .authStateParam as AuthentificationState;

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (
      status === AuthentificationStatus.NotAuthenticated &&
      visible &&
      authStateParam !== authState
    ) {
      routeNavigation.push({
        href: `/auth/${authState}`,
        routerDirection: 'none' as const,
      });
    }
  }, [authState, visible]);

  useEffect(() => {
    if (authState !== authStateParam) {
      changeState({ authState: authStateParam });
    }
    setVisible(true);
  }, [authStateParam]);

  let children = <LoadingScreen />;

  switch (authStateParam) {
    case AuthentificationState.SignedOut:
      children = <AuthentificationSignedOut />;
      break;
    case AuthentificationState.SignIn:
      children = <AuthentificationSignIn />;
      break;
    case AuthentificationState.SignUp:
      children = <AuthentificationSignUp />;
      break;
    case AuthentificationState.ConfirmSignUp:
      children = <AuthentificationConfirmSignUp />;
      break;
    case AuthentificationState.ForgotPassword:
      children = <AuthentificationForgotPassword />;
      break;
    case AuthentificationState.ConfirmForgotPassword:
      children = <AuthentificationConfirmForgotPassword />;
      break;
    case AuthentificationState.SelectSport:
      children = <AuthentificationSelectSport />;
      break;
    case AuthentificationState.SelectClub:
      children = <AuthentificationSelectClub />;
      break;
    case AuthentificationState.SelectTeam:
      children = <AuthentificationSelectTeam />;
      break;
    case AuthentificationState.BecomeFan:
      children = <AuthentificationBecomeFan />;
      break;
  }

  return <AuthentificationLayout>{children}</AuthentificationLayout>;
};

export default Authentification;
